import { useState } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formConfigFirstStep } from "../form-config";
import { useLazyCheckUsersLoginQuery } from "../../../../middleware/usersApi";
import FormItem from "../../../components/FormItem";

import { WatchDocModal } from "../../../components/WatchDocModal";
import privacy_policy from "../../../../image/Docs/privacy_policy.pdf";
import usage_rules from "../../../../image/Docs/usage_rules.pdf";
import user_access from "../../../../image/Docs/user_access.pdf";

const FirstStep = ({ setAuthStep }) => {
  const { t } = useTranslation();
  const [openDogovor1, setOpenDogovor1] = useState(false);
  const [openDogovor2, setOpenDogovor2] = useState(false);
  const [openDogovor3, setOpenDogovor3] = useState(false);

  const [checkUserLogin] = useLazyCheckUsersLoginQuery();

  const {
    control,
    handleSubmit,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const checkedConfirm = watch("confirm");

  const onSubmit = async (data) => {
    const response = await checkUserLogin(data);
    if (response.error?.status === 404) {
      setError("login", { type: "custom", message: "user_not_found" });
      return;
    }
    setAuthStep(1);
  };
  return (
    <>
      <form
        id="loginForm"
        className="object-form first_step"
        style={{ width: "646px" }}
        onSubmit={handleSubmit(onSubmit)}
      >
        {formConfigFirstStep.map(({ name, label, input, ...rest }) => (
          <FormItem key={name} control={control} errors={errors} name={name} label={label} input={input} {...rest} />
        ))}

        <Button fullWidth className="btn btn-primary-fill first_step-btn_next" variant="contained" type="submit">
          {t("button:continue")}
        </Button>

        <Box className="confirm_conditions">
          <Typography component={"span"}>
            Нажимая «Продолжить», вы даете
            <Typography
              component={"span"}
              className="btn btn-link"
              onClick={setOpenDogovor1.bind(null, true)}
              sx={{ cursor: "pointer" }}
            >
              {" "}
              согласие на обработку персональных данных
            </Typography>
            , принимаете
            <Typography
              sx={{ cursor: "pointer" }}
              component={"span"}
              className="btn btn-link"
              onClick={setOpenDogovor3.bind(null, true)}
            >
              {" "}
              пользовательское соглашение
            </Typography>
            {" "}
            и
            <Typography
              component={"span"}
              className="btn btn-link"
              onClick={setOpenDogovor2.bind(null, true)}
              sx={{ cursor: "pointer" }}
            >
              {" "}
              политику конфиденциальности
            </Typography>
          </Typography>

          {/*<Controller
            name="confirm"
            control={control}
            defaultValue={false}
            render={({ field }) => (
              <FormControlLabel control={<Checkbox {...field} />} label={t("label:confirm_conditions")} />
            )}
          />*/}
        </Box>
      </form>
      {openDogovor1 && (
        <WatchDocModal
          open={openDogovor1}
          name={"Согласие на обработку персональных данных.pdf"}
          handleClose={setOpenDogovor1.bind(null, false)}
          fileInfo={user_access}
        />
      )}
      {openDogovor2 && (
        <WatchDocModal
          open={openDogovor2}
          name={"Политика_конфиденциальности.pdf"}
          handleClose={setOpenDogovor2.bind(null, false)}
          fileInfo={privacy_policy}
        />
      )}
      {openDogovor3 && (
        <WatchDocModal
          open={openDogovor3}
          name={"Пользовательское соглашение.pdf"}
          handleClose={setOpenDogovor3.bind(null, false)}
          fileInfo={usage_rules}
        />
      )}
    </>
  );
};

export default FirstStep;
